import FingerprintJS from '@fingerprintjs/fingerprintjs';
import Cookies from 'js-cookie';
import datareport from '@util/datareport';
import datareport2 from '@util2/datareport/report';
import axios from './axios';

// 创建指纹
const _createFingerprint = async () => {
  try {
    const fp = await FingerprintJS.load();
    const { visitorId } = await fp.get();
    return visitorId;
  } catch (err) {
    return -1; // 创建失败
  }
};

export const setFingerprint = () =>
  // eslint-disable-next-line no-async-promise-executor
  new Promise(async (resolve) => {
    if (!window) {
      resolve(null);
      return;
    }

    let fp = '';

    try {
      fp = await axios.get('/fp'); // 使用 api 读取 httpOnly 的 cookie

      if (fp) {
        resolve(fp);
      } else {
        const fpCookieKey = 'prfb'; // block fingerprint 的缩写 -> 倒序
        const create = async () => {
          const browserValue = await _createFingerprint();
          Cookies.set(fpCookieKey, browserValue);

          await axios.get('/efp'); // 调用接口对 fp 进行加密
          const value = await axios.get('/fp'); // 获取加密后的 value
          resolve(value);
        };

        if (window.requestIdleCallback) {
          window.requestIdleCallback(create);
        } else {
          setTimeout(create, 500);
        }
      }
    } catch {
      resolve(null);
    }
  });

/**
 * 生成 fp 后更新 report 上报的属性
 */
export const setFingerprintAndUpdateReportParam = () => {
  // 生成指纹
  setFingerprint().then((fp) => {
    datareport.setDataParams({ fp });
    datareport2.setDataParams({ fp });
  });
};
